import { useEffect, useRef, useState } from "react";
import "../styles/curlCommand.css";

const COMMAND = "curl https://lebed.dev";

export default function CurlCommand() {
  const [status, setStatus] = useState("");
  const timer = useRef(null);
  const attempt = useRef(0);

  useEffect(() => {
    return () => {
      clearTimeout(timer.current);
      attempt.current += 1;
    };
  }, []);

  const copy = async (event) => {
    event.stopPropagation();
    clearTimeout(timer.current);
    const current = ++attempt.current;
    setStatus("");
    let message;
    try {
      if (!navigator.clipboard?.writeText) {
        throw new Error("Clipboard unavailable");
      }
      await navigator.clipboard.writeText(COMMAND);
      message = "Copied";
    } catch {
      message = "Copy unavailable";
    }
    if (current !== attempt.current) return;
    setStatus(message);
    timer.current = setTimeout(() => setStatus(""), 1800);
  };

  return (
    <span className="curl-command">
      <button
        type="button"
        className="curl-command-button"
        aria-label={`Copy ${COMMAND}`}
        title="Copy command"
        onClick={copy}
      >
        <code>{COMMAND}</code>
      </button>
      <output
        className="curl-command-status"
        data-error={status === "Copy unavailable" ? "true" : undefined}
        aria-live="polite"
      >
        {status}
      </output>
    </span>
  );
}
